import React, { useRef } from "react";
import { Badge, Button, Col, Form, Modal, Row, Spinner, Table } from "react-bootstrap";
import Fontstyling from "../../../components/common/comman";
import { useState, useEffect } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import Required from "../../../components/Required";
import { useSelector } from "react-redux";
import { CreateOrUpdateGPO, CreateOrUpdatePeriodData, GetAllGPO, GetCurrentPeriod, GetCurrentPeriodData, ImportRxBlockPricingForInternalUser } from "../../../api/EmpowRxApi/blockPricing";
import moment from "moment";
import toastFile from "../../../Service/ToastFile";
import editIcon from "../../../assets/icon/pencil-fill.svg";
import { IoCheckmarkCircle } from "react-icons/io5";
import CustomButton from "../../../components/common/CustomButton";
import { DownloadCensusErrorFile } from "../../../api/User/ACG/ImportCensusApi";
import { Loader } from "rsuite";

const warnMessages = {
    1: "New period can only be opened during the last 7 days of the current period and the first 15 days of the next period.",
    2: "Both open edit dates need to be in the month after current period.",
    3: "It is too late to extend open editing period for the current period.",
    4: "End Date cannot be more than 1 month after Start Date.",
    5: "Start Date and End Date must be in the same period.",
    6: "Can't Extend Allow Edit Period before current extended Allow Edit Period.",
};

const alertMessages = {
    1: {
        title: 'Open new period',
        message: 'You have selected to open a new period. Once complete you will not be able review the rates for current period anymore. This action is not reversable. Do you want to proceed?'
    },
    2: {
        title: 'Update Vendor',
        message: 'You have chosen to update vendor. This action is not reversable. Do you want to proceed?'
    },
    3: {
        title: 'Add Vendor',
        message: 'You have chosen to add a new vendor. This action is not reversable. Do you want to proceed?'
    },
};

const ADD_DAYS_FOR_ALLOW_EDIT = 14;

const OpenUpdatePeriod = () => {
    const userRoleString = "user";
    const schemaVendor = Yup.object().shape({
        GPO: Yup.string().trim().required("requried"),
    });
    const addNewVendorRef = useRef();
    const fileInputRef = useRef();
    const user = useSelector((state) => state.userDetails.value);
    const [showModal, setShowModal] = useState(0)
    const [showWarnModal, setShowWarnModal] = useState(0)
    const [last7DaysNext15Days, setLast7DaysNext15Days] = useState([]);
    const [last7Days, setLast7Days] = useState([]);
    const [currentPeriod, setCurrentPeriod] = useState(null);
    const [vendorModal, setVendorModal] = useState(false)
    const [selectedItem, setSelectedItem] = useState(null);
    const [allGPOData, setAllGPOData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isNewVendorLoading, setIsNewVendorLoading] = useState(false);
    const [message, setMessage] = useState({
        isModal: false,
        file: "",
        success: undefined,
      });

    useEffect(() => {
        getCurrentPeriod();
        getGPOList();
        getLast7DaysNext15Days();
    }, []);

    const getCurrentPeriod = () => {
        let request_date = moment().format("YYYY-MM-DD");
        GetCurrentPeriodData(request_date)
            .then((res) => {
                if (res?.status === 200) {
                    let data = res.data.data;
                    setCurrentPeriod(data);
                }
            })
            .catch((err) => console.log({ err }));
    };

    const getGPOList = () => {
        setIsLoading(true);
        GetAllGPO()
            .then((res) => {
                if (res?.status === 200) {
                    setAllGPOData(res.data.data);
                }
                setIsLoading(false);
            })
            .catch((err) => console.log({ err }));
    };

    const getNextQuarterOpenEditDates = () => {
        let today = moment();
        let isLast7Days =last7Days.includes(today.format("MM/DD/YYYY")); 
        let nextQuarterStart;
        let nextQuarterEnd ;
        if(isLast7Days){
             nextQuarterStart = today.clone().add(1, 'quarter').startOf('quarter');
             nextQuarterEnd = nextQuarterStart.clone().add(ADD_DAYS_FOR_ALLOW_EDIT, 'days');
        }else{
            nextQuarterStart = today;
            nextQuarterEnd = nextQuarterStart.clone().add(ADD_DAYS_FOR_ALLOW_EDIT, 'days');
        }
        return {
            start: nextQuarterStart.format('YYYY-MM-DD'),
            end: nextQuarterEnd.format('YYYY-MM-DD')
        };
    };

    const onConfirm = () => {
        let openEdit = getNextQuarterOpenEditDates();
        let payload = {
            current_Period: currentPeriod?.currentPeriod,
            current_Period_Start_Date: currentPeriod?.currentPeriodStartDate,
            current_Period_End_Date: currentPeriod?.currentPeriodEndDate,
            open_Edit_Start_Date: openEdit.start,
            open_Edit_End_Date: openEdit.end,
            userId: user?.UD_id,
        };
        console.log({payload});
        CreateOrUpdatePeriodData(payload).then((res) => {
            console.log({res})
            if (res?.status === 200) {
                if(res?.data?.issuccess){
                    getCurrentPeriod();
                    toastFile("The new period has been added successfully. Please communicate with users regarding the new open editing period.", 'success')
                }else{
                    toastFile(res?.data?.message, "error")
                }
            }else{
                toastFile('Failed to add new period.', "error");
                // toastFile(res?.message, "error");
            }
        })
            .finally(()=>setShowModal(0));
    }

    const onDiscard = () => {
        setShowModal(0);
        setVendorModal(false);
        addNewVendorRef?.current?.resetForm();
    };

    const getCurrentQuarterByToday = () => {
        const currQuarter = moment().quarter();
        const startDate = moment().quarter(currQuarter).startOf('quarter').format('YYYY-MM-DD');
        const endDate = moment().quarter(currQuarter).endOf('quarter').format('YYYY-MM-DD');
        return {
            quarter: currQuarter,
            startDate: startDate,
            endDate: endDate
        };
    };

    const getLast7DaysNext15Days = () => {
        const currQuar = getCurrentQuarterByToday();
        const last7daysArr = [];
        let currentDay1 = moment(currQuar?.endDate);
        let daysFound1 = 0;
        while (currentDay1 >= moment(currQuar?.startDate) && daysFound1 < 7) {
            last7daysArr.push(currentDay1.format('MM/DD/YYYY'));
            daysFound1++;
            currentDay1.subtract(1, 'day');
        }
        setLast7Days(last7daysArr);
        let next15Days = [...last7daysArr];
        let currentDay2 = moment(currQuar?.startDate); 
        let daysFound2 = 0;
        while (currentDay2 <= moment(currQuar?.endDate) && daysFound2 < 15) {
            next15Days.push(currentDay2.format('MM/DD/YYYY'));
            daysFound2++;
            currentDay2.add(1, 'day');
        }
        setLast7DaysNext15Days(next15Days);
    };

    const onAddNewPeriod = (e) => {
        setSelectedItem(null);
        e.preventDefault();
        let today = moment().format("MM/DD/YYYY");
        let canAdd = last7DaysNext15Days.includes(today);
        if (canAdd) {
            setShowModal(1);
        } else {
            setShowWarnModal(1);
        }
    };

    const onSaveNewVendor = (value, hand) => {
        let payload = {
            id: 0,
            gpo: value?.GPO,
            isActive: true,
            startDate: moment().format('YYYY-MM-DD'),
            endDate: moment().add(ADD_DAYS_FOR_ALLOW_EDIT, 'days').endOf('day').format('YYYY-MM-DD'),
            userId: user?.UD_id
        }
        CreateOrUpdateGPO(payload).then((res) => {
            if (res?.status === 200) {
                setVendorModal(false);
                getGPOList();
                hand?.resetForm();
                toastFile("The new vendor has been added successfully. Please communicate with users regarding the open editing period.", 'success')
            }else{
                toastFile('Failed to add new vendor.', "error")
            }
        })
            .catch((err) => console.log({ err }));
    };

    const handleImportFile = (file) => {
        setMessage(true);
        setIsNewVendorLoading(true);
        if (file === null) {
          setIsNewVendorLoading(false);
        }  else {
            ImportRxBlockPricingForInternalUser(
                file,
                user?.UD_id,
                userRoleString
            )
            .then((res) => {
              if (res.status === 200) {
                if (res.data.success) {
                  if (res.data.message === "failed") {
                    setMessage((prev) => ({
                      isModal: true,
                      file: res.data.file,
                      success: true,
                    }));
                  } else if (res.data.message === "sucessfull") {
                    toastFile("imported");
                    getGPOList();
                  }
                } else {
                  switch (res.data.message) {
                    case "failed":
                      setMessage((prev) => ({
                        isModal: true,
                        file: res.data.file,
                        success: false,
                      }));
                      break;
                    case "Invalid Template!":
                      toastFile(
                        "File with invalid template. Please upload correct file."
                      );
                      break;
                    case "Not CSV file":
                      toastFile(
                        "The file is not in csv format. Please import csv file."
                      );
                      break;
                    default:
                      toastFile(res.data.message);
                      break;
                  }
                }
              }
            })
            .catch((err) => {
                toastFile("Failed to import new vendor", 'error');
            })
            .finally(() => {
              setIsNewVendorLoading(false);
              fileInputRef.current.value = "";
            });
        }
      };


    return (
        <div>
            <Modal
                show={showModal > 0}
                aria-labelledby="contained-modal-header-vcenter"
                // centered={false}
                size="md"
            >
                <Modal.Header
                    closeButton
                    onHide={() => {
                        setShowModal(0);
                    }}
                >
                    <Modal.Title
                        id="contained-modal-header-vcenter"
                        style={Fontstyling.modalHeading}
                    >
                        {alertMessages[showModal]?.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{alertMessages[showModal]?.message}</p>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        style={Fontstyling.savebutton}
                        onClick={() => {
                            if (showModal === 3) {
                                setVendorModal(true);
                                setShowModal(0);
                            } else {
                                onConfirm();
                            }
                        }}
                    >
                        Yes
                    </button>
                    <button
                        style={Fontstyling.cancelbutton}
                        onClick={() => {
                            onDiscard();
                        }}
                    >
                        No
                    </button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={showWarnModal > 0}
                aria-labelledby="contained-modal-header-vcenter"
                // centered={false}
                size="md"
            >
                <Modal.Header
                    closeButton
                    onHide={() => {
                        setShowWarnModal(0);
                    }}
                >
                    <Modal.Title
                        id="contained-modal-header-vcenter"
                        style={Fontstyling.modalHeading}
                    >
                        Warning:
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{warnMessages[showWarnModal]}</p>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        style={Fontstyling.cancelbutton}
                        onClick={() => {
                            setShowWarnModal(0);
                        }}
                    >
                        Close
                    </button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={vendorModal}
                aria-labelledby="contained-modal-header-vcenter"
                // centered={false}
                size="md"
            >
                <Modal.Body>
                    <Formik
                        innerRef={addNewVendorRef}
                        enableReinitialize
                        validationSchema={schemaVendor}
                        onSubmit={onSaveNewVendor}
                        initialValues={{
                            GPO: '',
                        }}
                    >
                        {({
                            handleSubmit,
                            handleChange,
                            handleBlur,
                            setFieldValue,
                            setValues,
                            values,
                            touched,
                            isValid,
                            errors,
                            resetForm
                        }) => {

                            return (
                                <Form onSubmit={(e) => {
                                    handleSubmit(e);
                                }} id="vendorForm" >
                                    <Form.Group>
                                        <Form.Label style={Fontstyling.label}>
                                            Please Enter A Vendor Name
                                            <Required />
                                        </Form.Label>
                                        <Form.Control
                                            className="rounded-0 py-1"
                                            style={{ ...Fontstyling.label, minWidth: "70px" }}
                                            type="text"
                                            placeholder="Enter Vendor Name"
                                            name="GPO"
                                            isInvalid={
                                                errors.GPO &&
                                                touched.GPO
                                            }
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.GPO}
                                        />
                                        {errors.GPO && touched.GPO && (
                                            <Form.Label style={Fontstyling.errorlabel}>
                                                {errors.GPO}
                                            </Form.Label>
                                        )}
                                    </Form.Group>
                                    <div className="text-end mt-3" >
                                        <button
                                        type="button"
                                            style={Fontstyling.cancelbutton}
                                            onClick={() => {
                                                setVendorModal(false);
                                            }}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            form='vendorForm'
                                            className="ms-3"
                                            style={Fontstyling.savebutton}
                                            type="submit"
                                        >
                                            Save
                                        </button>
                                    </div>
                                </Form>
                            );
                        }}
                    </Formik>
                </Modal.Body>
            </Modal>
            <Row className=" my-3 gap-5 justify-content-between">
                <Col className=" ">
                    <Form.Group className="gap-3 ">
                        <Form.Label
                            className="text-nowrap "
                            style={Fontstyling.label}
                        >
                            Current Period:
                        </Form.Label>
                        <Form.Control
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            name="Current_Period"
                            disabled
                            value={currentPeriod?.currentPeriod}
                        >
                        </Form.Control>

                    </Form.Group>
                </Col>
                <Col className=" ">
                    <Form.Group className=" gap-3 ">
                        <Form.Label
                            className="text-nowrap "
                            style={Fontstyling.label}
                        >
                            Period Start Date:
                        </Form.Label>
                        <Form.Control
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            name="Current_Period_Start_Date"
                            type="text"
                            disabled
                            value={moment(currentPeriod?.currentPeriodStartDate).format("MM/DD/YYYY")}
                        >
                        </Form.Control>
                    </Form.Group>
                </Col>
                <Col className=" ">
                    <Form.Group className="gap-3 ">
                        <Form.Label
                            className="text-nowrap "
                            style={Fontstyling.label}
                        >
                            Period End Date:
                        </Form.Label>
                        <Form.Control
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            name="Current_Period_End_Date"
                            type="text"
                            disabled
                            value={moment(currentPeriod?.currentPeriodEndDate).format("MM/DD/YYYY")}
                        >
                        </Form.Control>

                    </Form.Group>
                </Col>
            </Row>
            <Row className="text-end my-3">
                <Col>
                    <button
                        className="text-nowrap"
                        style={{ ...Fontstyling.savebutton }}
                        onClick={onAddNewPeriod}
                    >
                        Add New Period
                    </button>
                </Col>
            </Row>
                    <div style={Fontstyling.heading}>Allow Edit Periods:</div>
                  
            <Table bordered hover responsive className="mt-2" style={{ width: '76%' }}>
                <thead style={Fontstyling.label} >
                    <tr className="text-center align-middle">
                        {[
                            "Aggregator/Coalition/GPO/PBM",
                            "Start Date",
                            "End Date",
                            "Current Allow Edit",
                            "Actions",
                        ].map((el, ind) => {
                            return (
                                <th key={ind}>
                                    {el}
                                    {/* {el !== "Actions" && <Required />} */}
                                </th>
                            );
                        })}
                    </tr>
                </thead>
                <tbody>
                    {isLoading ?
                        <tr>
                            <td className="text-center" colSpan={5}>
                                <Loader size="md" className="m-0" />
                            </td>
                        </tr>

                        : allGPOData?.length > 0 ?
                            allGPOData?.map((row, rowInd) => (
                                <AllowEditPeriods
                                    key={rowInd}
                                    rowInd={rowInd}
                                    row={row}
                                    allGPOData={allGPOData}
                                    setAllGPOData={setAllGPOData}
                                    selectedItem={selectedItem}
                                    setSelectedItem={setSelectedItem}
                                    currentPeriod={currentPeriod}
                                />
                            )) :
                            <tr >
                                <td className="text-center" colSpan={5}
                                    style={{
                                        margin: 0,
                                        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                                        fontWeight: "bold",
                                        fontSize: 14,
                                        color: " rgba(0, 0, 0, 0.6)",
                                        fontStyle: "italic",
                                        width: "100%"
                                    }}
                                >No Records Found.</td>
                            </tr>
                    }
                </tbody>
            </Table>
            <div className="mb-3" style={Fontstyling.heading}>Add New Vendor:</div>
                    {/* Error model 2 */}
                    <Modal
                        show={message.isModal && message.success === false}
                        onHide={() => setMessage((prev) => ({ ...prev, isModal: false }))}
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>Error</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            There are blank or invalid values in your import file. Please click
                            Download Error Log, correct the import file accordingly, and try
                            again.
                        </Modal.Body>
                        <Modal.Footer>
                            <div>
                                <Button
                                    className="bg-transparent border-0 text-primary"
                                    onClick={() => {
                                        DownloadCensusErrorFile(message.file).then((data) => {
                                            const blob = new Blob([data.data], {
                                                type: "text/plain",
                                            });
                                            const url = URL.createObjectURL(blob);
                                            const a = document.createElement("a");
                                            a.href = url;
                                            a.download = message.file;
                                            document.body.appendChild(a);
                                            a.click();
                                            document.body.removeChild(a);
                                            URL.revokeObjectURL(url);
                                            setMessage((prev) => ({ ...prev, isModal: false, file: "" }));
                                        });
                                    }}
                                >
                                    Download Error Log
                                </Button>
                            </div>
                        </Modal.Footer>
                    </Modal>
                    <Row className="my-3">
                        <Col className="col-8" style={Fontstyling.label}>
                            <ul className="mb-0" style={{ listStyle: 'none' }}>
                                <li>Step 1: Click the “New Vendor Template” link below to download the template</li>
                                <a
                                      className="ms-5 mb-0"
                                      href="/samplefile/New_Vendor_Template.csv"
                                      style={Fontstyling.label}
                                      download
                                    >
                                      New Vendor Template
                                    </a>
                                <li>Step 2: Delete the sample records from the template.</li>
                                <li>Step 3: Create rate records for the new vendor</li>
                                      <p className="ms-5 mb-0" style={{fontWeight:'bold'}}>NOTE: </p>
                                      <p className="mt-0 mb-0" style={{marginLeft:'80px'}}> a. <span style={{fontWeight:'bold'}}>DO NOT</span> change column name and column headers orders. </p>
                                      <p className="mt-0 mb-0" style={{marginLeft:'80px'}}> b. No blank fields are allowed. If a rate is not available, please enter 0.</p>
                                      <p className="mt-0 mb-0" style={{marginLeft:'80px'}}> c. All rates need to be in number format. For example, 0.0125 should be entered, instead of 1.25%</p>
                                <li>Step 4: Save it as a CSV file</li>
                                <li>Step 5: Click the “Import New Vendor” button, to import the file. The new vendor will be added to the system once the import is completed. </li>
                            </ul>
                        </Col>
                        <Col className="d-flex flex-column align-items-end justify-content-end">
                            <div className="">
                                <CustomButton
                                    className="text-nowrap d-flex gap-2 align-items-center"
                                    style={Fontstyling.savebutton}
                                    onClick={() => {
                                        fileInputRef?.current?.click();
                                    }}
                                >
                                    {isNewVendorLoading &&

                                        <Loader className="m-0" />
                                    }  Import New Vendor
                                </CustomButton>

                                <br />
                            </div>
                            <div >
                                <input
                                    type="file"
                                    accept=".csv"
                                    ref={fileInputRef}
                                    className='py-1 rounded-0 d-none'
                                    style={Fontstyling.label}
                                    placeholder="Select File"
                                    name="file"
                                    onChange={(e) => {
                                        const file = e.target.files[0];
                                        handleImportFile(file);
                                    }}
                                />
                            </div>
                        </Col>
                    </Row>
        </div>
    );
};

export default OpenUpdatePeriod;

const AllowEditPeriods = ({
    row,
    rowInd,
    allGPOData,
    setAllGPOData,
    selectedItem,
    setSelectedItem,
    currentPeriod
}) => {

    const formikRef = useRef();
    const user = useSelector((state) => state.userDetails.value);

    const {
        Id,
        Label,
        Start_Date,
        End_Date,
    } = row;

    const startDate = moment(Start_Date).format("YYYY-MM-DD");
    const endDate = moment(End_Date).format("YYYY-MM-DD");

    // const schemaTable = Yup.object().shape({
    //     Start_Date: Yup.date().required("Please enter start date"),
    //     End_Date: Yup.date().required("Please enter  end date")
    // });
    const schemaTable = Yup.object().shape({
        Start_Date: Yup.date()
            .required("Please enter start date")
            .test('start-date', 'Start date must be before end date', function(value) {
                const end_date = this.resolve(Yup.ref('End_Date'));
                return !end_date || !value || value <= end_date;
            }),
        End_Date: Yup.date()
            .required("Please enter end date")
    });
    

    const initialValues = {
        GPO: Label ?? '',
        Start_Date: startDate ?? '',
        End_Date: endDate ?? '',
    };

    const [currAllowEdit, setCurrAllowEdit] = useState(false);
    const [showModal, setShowModal] = useState(0)
    const [showWarnModal, setShowWarnModal] = useState(0)

    useEffect(() => {
        setCurrAllowEdit(checkDateBetween(Start_Date, End_Date));
    }, [allGPOData]);

    useEffect(() => {
        formikRef?.current?.resetForm();
    }, [selectedItem]);

    const checkDateBetween = (start, end) => {
        let today = moment();
        let startDate = moment(start, 'YYYY-MM-DD').startOf('day').format("YYYY-MM-DDTHH:mm:ss");
        let endDate = moment(end, 'YYYY-MM-DD').endOf('day').format("YYYY-MM-DDTHH:mm:ss");
        let isWithinRange = today.isBetween(startDate, endDate, null, '[]');
        return isWithinRange;
    };

    const areDatesInCurrQuarter = (start, end) => {
        const date1 = moment(start, 'YYYY-MM-DD');
        const date2 = moment(end, 'YYYY-MM-DD');
        const currQuarStartDate = moment(currentPeriod?.currentPeriodStartDate, 'YYYY-MM-DD')
        const quarter1 = date1.quarter();
        const quarter2 = date2.quarter();
        const quarter3 = currQuarStartDate.quarter();
        const year1 = date1.year();
        const year2 = date2.year();
        const year3 = currQuarStartDate.year();
        return quarter1 === quarter2 && quarter1 === quarter3 && year1 === year2 && year1 === year3;
    };

    const areDatesInSameMonth = (start, end) => {
        const date1 = moment(start, 'YYYY-MM-DD');
        const date2 = moment(end, 'YYYY-MM-DD');
        return date1.month() === date2.month();
    };

    const isDateRangeWithinOneMonth = (start, end) => {
        const startDate = moment(start, 'YYYY-MM-DD');
        const endDate = moment(end, 'YYYY-MM-DD');
        const diffInDays = endDate.diff(startDate, 'days');
        return diffInDays < startDate.daysInMonth();
    };

    const onSaveIconClick = (values, handler) => {
        let { Start_Date, End_Date } = values;
        // console.log(values);
        let inSameMonth = areDatesInSameMonth(Start_Date, End_Date)
        let inRange = isDateRangeWithinOneMonth(Start_Date, End_Date)
        // if(!inSameMonth){
        //   setShowWarnModal();
        //   return
        // } 
        let inCurrQuarter = areDatesInCurrQuarter(Start_Date, End_Date)

        if (!inRange) {
            setShowWarnModal(4);
        } else if (!inCurrQuarter) {
            setShowWarnModal(5);
        } else {
            setShowModal(2);
        }
    };

    const onConfirm = () => {
        let { Start_Date, End_Date, GPO } = formikRef?.current?.values;
        let payload = {
            id: Id,
            gpo: GPO,
            isActive: true,
            // startDate: moment(Start_Date).startOf('day').toISOString(),
            // endDate: moment(End_Date).endOf('day').toISOString(),
            startDate: Start_Date,
            endDate: End_Date,
            userId: user?.UD_id
        }
        CreateOrUpdateGPO(payload).then((res) => {
            if (res?.status === 200) {
                setShowModal(0);
                setSelectedItem(null);
                toastFile("Vendor has been updated successfully. Please communicate with users regarding the extended open editing period.", 'success')
                let updatedData = [...allGPOData];
                updatedData.splice(rowInd, 1, { ...row, Start_Date: payload.startDate, End_Date: payload.endDate })
                setAllGPOData([...updatedData]);
                // console.log({ updatedData })
            }else{
                toastFile('Failed to update vendor.', "error")
            }
        })
            .catch((err) => console.log({ err }));
    };

    const onDiscard = () => {
        formikRef?.current?.resetForm();
        setSelectedItem(null);
        setShowModal(0);
    };

    return (
        <>
            <Modal
                show={showModal > 0}
                aria-labelledby="contained-modal-header-vcenter"
                // centered={false}
                size="md"
            >
                <Modal.Header
                    closeButton
                    onHide={() => {
                        setShowModal(0);
                    }}
                >
                    <Modal.Title
                        id="contained-modal-header-vcenter"
                        style={Fontstyling.modalHeading}
                    >
                        {alertMessages[showModal]?.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{alertMessages[showModal]?.message}</p>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        style={Fontstyling.savebutton}
                        onClick={() => {
                            onConfirm(Id);
                        }}
                    >
                        Yes
                    </button>
                    <button
                        style={Fontstyling.cancelbutton}
                        onClick={() => {
                            onDiscard();
                        }}
                    >
                        No
                    </button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={showWarnModal > 0}
                aria-labelledby="contained-modal-header-vcenter"
                // centered={false}
                size="md"
            >
                <Modal.Header
                    closeButton
                    onHide={() => {
                        setShowWarnModal(0);
                    }}
                >
                    <Modal.Title
                        id="contained-modal-header-vcenter"
                        style={Fontstyling.modalHeading}
                    >
                        Warning:
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{warnMessages[showWarnModal]}</p>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        style={Fontstyling.cancelbutton}
                        onClick={() => {
                            setShowWarnModal(0);
                        }}
                    >
                        Close
                    </button>
                </Modal.Footer>
            </Modal>

            <Formik
                innerRef={formikRef}
                enableReinitialize
                validationSchema={schemaTable}
                onSubmit={onSaveIconClick}
                initialValues={initialValues}
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    errors,
                    setFieldValue,
                    resetForm
                }) => (
                    <tr >
                        <td>
                            <Form.Group>
                                <Form.Control
                                    className="rounded-0 py-1"
                                    style={{ ...Fontstyling.label, minWidth: "70px" }}
                                    type="text"
                                    placeholder=""
                                    name="GPO"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    disabled
                                    value={values.GPO}
                                />
                            </Form.Group>
                        </td>
                        <td>
                            <Form.Group>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={{ width: '150px', ...Fontstyling.label }}
                                    name="Start_Date"
                                    type="date"
                                    min={moment().format("YYYY-MM-DD")}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    disabled={selectedItem?.Id !== Id}
                                    isInvalid={
                                        errors.Start_Date &&
                                        touched.Start_Date
                                    }
                                    value={values.Start_Date}
                                >
                                </Form.Control>
                                <Form.Control.Feedback type="invalid">
                                    {errors.Start_Date}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </td>
                        <td>
                            <Form.Group>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={{ width: '150px', ...Fontstyling.label }}
                                    name="End_Date"
                                    type="date"
                                    min={values.Start_Date}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isInvalid={errors.End_Date && touched.End_Date}
                                    disabled={selectedItem?.Id !== Id }
                                    value={values.End_Date}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.End_Date}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </td>
                        <td>
                            <Form.Group>
                                <Form.Control
                                    className="rounded-0 py-1"
                                    style={{ ...Fontstyling.label, minWidth: "70px" }}
                                    type="text"
                                    name="currentAllowEdit"
                                    disabled
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={currAllowEdit ? "Yes" : "No"}
                                />
                            </Form.Group>
                        </td>
                        <td className="text-center">
                            {selectedItem?.Id === Id ? (
                                <button
                                    className="btn p-0 m-0 rounded-circle border-0"
                                    type="submit"
                                    onClick={(e) => {
                                        handleSubmit(e);
                                    }}
                                >
                                    <IoCheckmarkCircle size={23} />
                                </button>
                            ) : (

                                <button
                                    className="btn p-0 m-0 rounded-circle border-0 pe-auto"
                                    type="button"
                                    onClick={() => {
                                        setSelectedItem(row);
                                    }}
                                >
                                    <img src={editIcon} />
                                </button>
                            )}
                        </td>
                    </tr>
                )}
            </Formik>
        </>
    );
};




